export enum ContactsStackRoutes {
  CONTACTS_MENU = "Контакти (Меню)",
  FACULTIES = "Факультети",
}
